export const roles = { portal: 'PROP_MAZKARTE_RW', texts: 'PROP_TEXT_RO' };
export const rolesArray = Object.values(roles);
